import { Boundaries } from "@planzone/core";
import { editTaskError } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { task }: Boundaries["editTask"]["request"],
): State {
  const index = state.findIndex((req) => req.task.uuid === task.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          task,
          request: setRequestStateToPending(),
          error: editTaskError,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          task,
          request: setRequestStateToPending(),
          error: editTaskError,
        },
      ];
}

function handleSuccess(
  state: State,
  task: Boundaries["editTask"]["success"],
): State {
  const index = state.findIndex((req) => req.task.uuid === task.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          task,
          request: setRequestStateToSuccess(),
          error: editTaskError,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          task,
          request: setRequestStateToSuccess(),
          error: editTaskError,
        },
      ];
}

function handleFailure(
  state: State,
  { error, task }: Boundaries["editTask"]["failure"],
): State {
  const index = state.findIndex((req) => req.task.uuid === task.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          task,
          request: setRequestStateToFailure(),
          error,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          task,
          request: setRequestStateToFailure(),
          error,
        },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editTaskRequested]: handleRequest,
    [events.editTaskSucceeded]: handleSuccess,
    [events.editTaskFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
